import React, { useMemo, useCallback } from 'react';
import { Box, Flex, Icon, Image, Text } from '@chakra-ui/core';
import { RiFileLine } from 'react-icons/ri';
import { AnswerFile, fileKind, getDocumentFileName } from '../documentRenderer.types';
import { ReactComponent as PdfIcon } from '../../../../../../assets/img/icon-pdf.svg';
import { ReactComponent as WordIcon } from '../../../../../../assets/img/icon-doc.svg';

export interface FilePreviewProps {
  file: AnswerFile;
  onOpen: (file: AnswerFile) => void;
}

const FilePreview: React.FC<FilePreviewProps> = ({ file, onOpen }) => {
  const type = useMemo(() => fileKind(file), [file]);

  const displayName = useMemo(() => getDocumentFileName(file.name), [file.name]);

  const icon = useMemo(() => {
    switch (type) {
      case 'pdf':
        return <Icon as={PdfIcon} width="40px" height="40px" />;
      case 'word':
        return <Icon as={WordIcon} width="40px" height="40px" />;
      default:
        return <Icon as={RiFileLine} width="40px" height="40px" color="#2D3748" />;
    }
  }, [type]);

  const handleClick = useCallback(() => onOpen(file), [file, onOpen]);

  return (
    <Box onClick={handleClick} cursor="pointer" _hover={{ transform: 'translateY(-2px)' }} transition="0.2s">
      <Box bg="white" borderRadius="8px" overflow="hidden" p={2} minH="140px" border="1px solid" borderColor="gray.200">
        <Flex align="center" justify="center" bg="gray.50" borderRadius="6px" height="90px" overflow="hidden">
          {type === 'image' ? <Image src={file.url} alt={displayName} objectFit="cover" width="100%" height="100%" /> : icon}
        </Flex>

        <Text mt={2} fontSize="xs" textAlign="center" color="gray.700" noOfLines={1} title={displayName}>
          {displayName}
        </Text>
      </Box>
    </Box>
  );
};

export default React.memo(FilePreview);
